import { Icon, IconSet } from '@postscript/components';
import { useBanners } from 'components/GlobalBanners/globalBanners';
import { BLOCK_POPUP_PATHS } from 'components/popups/constants';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { BANNER_TYPES } from 'utils/events';
import { LEARN_MORE_URL } from './constants';
import { useAiEligibleSubscribers } from './useAiEligibleSubscribers';

const BANNER_ID = 'AI_ELIGIBILITY_NON_ELIGIBLE_SOURCE_SHIFT';

// L30 absolute drop in AI-eligible percent that triggers the banner. Tunable
// during QA against real shop data.
const L30_ELIGIBILITY_DROP_THRESHOLD = -0.05;

const HighlightBulbIcon = (): JSX.Element => (
  <Icon component={IconSet.Bulb} color="var(--highlight-color)" size={24} />
);

export const useNonEligibleSourceShiftBanner = (): void => {
  const { addBanner, removeBanner } = useBanners();
  const history = useHistory();

  const { data } = useAiEligibleSubscribers();

  const l30Change = data?.change ?? null;
  const belowThreshold =
    l30Change !== null && l30Change <= L30_ELIGIBILITY_DROP_THRESHOLD;

  useEffect(() => {
    if (!belowThreshold) {
      removeBanner(BANNER_ID);
      return;
    }

    addBanner({
      id: BANNER_ID,
      isDismissable: false,
      customIcon: HighlightBulbIcon,
      data: {
        variant: 'guidance',
        heading: 'Drive higher ROI from SMS with this one change',
        bodyText:
          'Postscript AI products consistently drive higher ROI — but only for AI Eligible Subscribers. Turn on a Postscript Popup to compliantly increase your AI reach.',
        primaryAction: {
          text: 'Learn more',
          onClick: () => window.open(LEARN_MORE_URL, '_blank', 'noopener'),
        },
        secondaryAction: {
          text: 'Create a Postscript Popup',
          onClick: () => history.push(BLOCK_POPUP_PATHS.LIST),
        },
      },
      eventTrackingOptions: {
        bannerType: BANNER_TYPES.AI_ELIGIBILITY_SOURCE_SHIFT,
      },
    });
  }, [belowThreshold, addBanner, removeBanner, history]);
};
